import ContextMenu from "pages/_components/ContextMenu";
import TransactionTicket from "pages/_components/TransactionTicket";
import RecurrencyTransactionData from "pages/debinPayments/_components/recurrentDebin/RecurrencyTransactionData";
import ModifyPendingTransactionModal from "pages/transactions/_components/ModifyPendingTransactionModal";
import { bool, func, shape } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { selectors as debinSelectors } from "reducers/debin";
import { actions as formActions } from "reducers/form";
import * as i18n from "util/i18n";
import { exportGenericTicketPdfWithSuccessMessage, getGeneralTicketItem } from "util/transaction";
import { actions as notificationActions } from "reducers/notification";
import { get as getMessage } from "util/i18n";
import { resizableRoute } from "pages/_components/Resizable";

const FORM_ID = "debin.recurrency";
class RecurrencyTransaction extends Component {
    static propTypes = {
        recurrencyAction: shape({}).isRequired,
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        fetching: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    state = {
        isModalDisplayed: false,
        showDrawerMobile: false,
        fetchingDownload: false,
    };

    componentDidMount() {
        const { dispatch, recurrencyAction } = this.props;
        if (!recurrencyAction.idTransaction && localStorage.getItem("flow")) {
            dispatch(push(`${JSON.parse(localStorage.getItem("flow"))}`));
        }
    }

    centerContentMobile = (title) => (
        <div className="title-account-header-multiline-background-blue">
            <h1 className="w-100 px-2">{i18n.get(title)}</h1>
        </div>
    );

    summaryDataComponent = () => <RecurrencyTransactionData />;

    signTransaction = () => {
        const { dispatch, recurrencyAction } = this.props;

        const signTransactionData = this.summaryDataComponent();
        const cuotas = recurrencyAction.limite_cuotas;

        dispatch(push("/transactions/sign"));
        dispatch(
            formActions.signTransactionData({
                idTransaction: recurrencyAction?.idTransaction,
                idActivity: recurrencyAction.idActivity,
                idForm: "",
                content: signTransactionData,
                title: cuotas
                    ? `debin.programmed.transaction.${recurrencyAction?.action?.toLowerCase()}.title`
                    : `debin.recurrency.transaction.${recurrencyAction?.action?.toLowerCase()}.title`,
            }),
        );

        dispatch(
            formActions.signTransactionPreview({
                idActivity: recurrencyAction.idActivity,
                idTransaction: recurrencyAction.idTransaction,
                idForm: "",
                ticketData: recurrencyAction,
            }),
        );
    };

    rightContentTransactionScheme = () => {
        const { recurrencyAction, isDesktop } = this.props;

        if (recurrencyAction?.idTransactionStatus === "FINISHED") {
            return (
                <ContextMenu
                    isDesktop={isDesktop}
                    color={!isDesktop ? "white" : undefined}
                    buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                    items={[
                        {
                            label: "global.download",
                            onClick: this.exportPdf,
                        },
                    ]}
                />
            );
        }

        return (
            <>
                {recurrencyAction?.idTransactionStatus !== "CANCELLED" && (
                    <ContextMenu
                        isDesktop={isDesktop}
                        color={!isDesktop ? "white" : undefined}
                        buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                        items={[
                            {
                                label: "pendingTransaction.info.scheme",
                                onClick: () => this.setState({ showDrawerMobile: true }),
                            },
                        ]}
                    />
                )}
            </>
        );
    };

    exportPdf = async () => {
        this.setState({ fetchingDownload: true });
        const { recurrencyAction, dispatch } = this.props;

        const cuotas = recurrencyAction.limite_cuotas;

        const ticketItems = [
            getGeneralTicketItem("negotiate.transaction.date.label", recurrencyAction?.creationDate, "datefulltime"),
            getGeneralTicketItem(
                `payments.debin.detail.table.header.voucher`,
                recurrencyAction?.idTransaction.substring(0, 8).toUpperCase(),
                "string",
            ),
            getGeneralTicketItem(`${FORM_ID}.account.title`, recurrencyAction?.accountFull, "string"),
        ];

        ticketItems.push(
            getGeneralTicketItem(`${FORM_ID}.seller.name.title`, recurrencyAction?.sellerInfo?.titular || "", "string"),
        );

        ticketItems.push(getGeneralTicketItem(`${FORM_ID}.seller.cuit.title`, recurrencyAction?.seller, "string"));

        if (cuotas !== undefined && cuotas !== null) {
            ticketItems.push(
                getGeneralTicketItem("debin.programmed.transaction.installments.title", cuotas.toString(), "string"),
            );
        }

        ticketItems.push(
            getGeneralTicketItem(`${FORM_ID}.prestacion.title`, recurrencyAction?.prestacion, "string"),
            getGeneralTicketItem(
                `${FORM_ID}.concept.title`,
                recurrencyAction?.concepto
                    ? `${recurrencyAction?.concepto} - ${i18n.get(`transfers.concept.${recurrencyAction?.concepto}`)}`
                    : "",
                "string",
            ),
            getGeneralTicketItem(`${FORM_ID}.reference.title`, recurrencyAction?.detalle, "string"),
            getGeneralTicketItem(`${FORM_ID}.descripcion.title`, recurrencyAction?.referencia, "string"),
        );

        ticketItems.push(
            getGeneralTicketItem(`${FORM_ID}.coelsa.response`, recurrencyAction?.coelsaResponse, "string"),
            getGeneralTicketItem(`${FORM_ID}.coelsa.code`, recurrencyAction?.coelsaCode, "string"),
        );

        const ticketData = {
            ticketName: cuotas
                ? i18n.get(`debin.programmed.transaction.${recurrencyAction?.action}.title`.toLowerCase())
                : i18n.get(`debin.recurrency.transaction.${recurrencyAction?.action}.title`.toLowerCase()),
            ticketBody: ticketItems,
        };

        await exportGenericTicketPdfWithSuccessMessage(ticketData, dispatch, i18n.get("global.download.success"));

        this.setState({ fetchingDownload: false });
    };

    buttonsDetail = () => {
        const { dispatch, recurrencyAction } = this.props;

        if (recurrencyAction) {
            const { idTransactionStatus } = recurrencyAction;
            if (idTransactionStatus !== "PENDING") {
                if (recurrencyAction.limite_cuotas && recurrencyAction.isNewTransaction) {
                    return [
                        {
                            label: "debin.programmed.transaction.goToScheduled",
                            bsStyle: "primary",
                            onClick: () => {
                                dispatch(
                                    notificationActions.showNotification(
                                        getMessage(`debin.scheduled.${recurrencyAction?.action.toLowerCase()}.success`),
                                        "success",
                                        ["debin.scheduled"],
                                    ),
                                );
                                dispatch(push("/v2/debin/scheduled"));
                            },
                        },
                    ];
                }
                return [
                    {
                        label: "global.goToHome",
                        bsStyle: "primary",
                        onClick: () => dispatch(push("/desktop")),
                    },
                ];
            }
        }
        return [];
    };

    render() {
        const { recurrencyAction, isDesktop, dispatch, isSmallDesktop, fetching, embeddedInV3Shell } = this.props;
        const { isModalDisplayed, showDrawerMobile, fetchingDownload } = this.state;

        const cuotas = recurrencyAction.limite_cuotas;

        const title = cuotas
            ? `debin.programmed.transaction.${recurrencyAction?.action?.toLowerCase()}.title`
            : `debin.recurrency.transaction.${recurrencyAction?.action?.toLowerCase()}.title`;

        return (
            <>
                {recurrencyAction?.idTransaction && (
                    <TransactionTicket
                        embeddedInV3Shell={embeddedInV3Shell}
                        embeddedV3GoBackPath="/payments/recurrent"
                        fetching={fetching}
                        notificationScope="debinRecurringTransaction"
                        handleClick={this.exportPdf}
                        handleClickMessage="global.download"
                        uniqueDownload={recurrencyAction?.idTransactionStatus === "FINISHED"}
                        rightContent={
                            recurrencyAction?.idTransactionStatus === "PENDING" && this.rightContentTransactionScheme
                        }
                        emptyRightOption={
                            (isDesktop && recurrencyAction?.idTransactionStatus !== "FINISHED") ||
                            (!isDesktop &&
                                recurrencyAction?.idTransactionStatus !== "PENDING" &&
                                recurrencyAction?.idTransactionStatus !== "FINISHED")
                        }
                        downloadImageWhite={!isDesktop}
                        headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                        centerElement={!isDesktop && (() => this.centerContentMobile(title))}
                        hasInlineButtons
                        hideMobileMenu={!isDesktop}
                        summary={recurrencyAction}
                        buttonsDetail={this.buttonsDetail()}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        showDrawerMobile={showDrawerMobile}
                        closeMobileDrawer={() => this.setState({ showDrawerMobile: false })}
                        onSignTicket={this.signTransaction}
                        ignoreHomeButton
                        summaryTitle={title}
                        isFetchingExport={fetchingDownload}>
                        <ModifyPendingTransactionModal
                            isDesktop={isDesktop}
                            isDisplayed={isModalDisplayed}
                            handleDismiss={this.handleDismiss}
                            dispatch={dispatch}
                            idTransaction={recurrencyAction.idTransaction}
                        />
                        <RecurrencyTransactionData isDesktop={isDesktop} />
                    </TransactionTicket>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    recurrencyAction: debinSelectors.getRecurrencyDebinAction(state),
    fetching: debinSelectors.getFetching(state),
});

export default connect(mapStateToProps)(resizableRoute(RecurrencyTransaction));
